var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.value,"fullscreen":"","scrollable":"","persistent":"","no-click-animation":"","transition":_vm.transition}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }